module.exports = __webpack_public_path__ + "static/media/10.1.537b27e8.png";